/* eslint-disable lodash/import-scope */
import _ from "lodash";
import React, { useEffect } from "react";
import { PolicyInfo } from "./policy-info";
import tsRest from 'ts-rest-client';
import { PleaseWaitSpinner } from "ts-common-react-controls/lib/module/waitspinner";

const tr = require('ts-translate-js').default.boundTR;
const trN = tr;

// Delivery helper functions
const PolicyType = {
    POLICY: "POLICY",
    DISCLAIMER: "DISCLAIMER"
};

type PoliciesProps = {
    integ: string,
    eventIds: number[],
    onCheckedChange: (policy: any, checked: boolean) => void,
    raiseContentChanged: () => void,
    initPoliciesRequest: (policiesToShow: any) => void
};

export function Policies({integ, eventIds, onCheckedChange, raiseContentChanged, initPoliciesRequest} : PoliciesProps) {
    const [policiesToShow, setPoliciesToShow] = React.useState(null);
    const [processing, setProcessing] = React.useState(false);

    useEffect(() => {
        const loadPolicies = async () => {
            setProcessing(true);
            if(integ)
            {
                let policies = await tsRest.post("integration/" + integ +  "/policies", { eventIds: eventIds, lang: tsapp.twoLetterLang });
                setProcessing(false);
                setPoliciesToShow(policies);
                initPoliciesRequest(policies);
            }
        };

        loadPolicies();
    }, [integ, eventIds, initPoliciesRequest]);

    let disclaimersSection = null;
    let policiesSection = null;

    if(policiesToShow && policiesToShow.length > 0) {

        const policiesByType = _.groupBy(policiesToShow, (policy) => {
            if(policy.type == PolicyType.DISCLAIMER || policy.type == null)
                return "Disclaimers";
            else if(policy.type == PolicyType.POLICY)
                return "Policies";
        });

        const disclaimersCtl = _.map(policiesByType.Disclaimers, (policy) =>
            <PolicyInfo key={policy.id} policy={policy} onCheckedChange={onCheckedChange} raiseContentChanged={raiseContentChanged}/>
        );

        const policiesCtl = _.map(policiesByType.Policies, (policy) =>
            <PolicyInfo key={policy.id} policy={policy} onCheckedChange={onCheckedChange} raiseContentChanged={raiseContentChanged}/>
        );

        disclaimersSection = (disclaimersCtl.length > 0) ? (
            <div>
                <h4>{trN("Décharge de responsabilité", "Décharges de responsabilité", { n: policiesByType.Disclaimers.length })}</h4>
                {disclaimersCtl}
            </div>
        ) : null;

        policiesSection = (policiesCtl.length > 0) ? (
            <div>
                <h4>{trN("Politique d'achat", "Politiques d'achat", { n: policiesByType.Policies.length })}</h4>
                {policiesCtl}
            </div>
        ) : null;
    }
    
    return (processing ? <PleaseWaitSpinner /> 
        : <div>
            {disclaimersSection}
            {policiesSection}
        </div>
    );
}